<template>
<div class="services">
  <transition name="services">
    <ServicesDesign
        v-if="servicesFilterStatus === 'design'"
    />
  </transition>
  <transition name="services">
    <ServicesRepair
        v-if="servicesFilterStatus === 'repair'"
    />
  </transition>
</div>
</template>

<script>
import ServicesDesign from "@/components/ServicesDesign";
import ServicesRepair from "@/components/ServicesRepair";
import {mapGetters} from "vuex";
export default {
  name: 'ServicesList',
  components: {
    ServicesDesign,
    ServicesRepair
  },
  methods: {},
  computed: {
    ...mapGetters(['servicesFilterStatus'])
  },
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.services-enter-active {
  animation: services .3s;
}
@keyframes services {
  0% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
